import { ISelectOption } from './select';

export enum MonitoringDeviceStatuses {
  Online = 'ONLINE',
  Offline = 'OFFLINE',
}

export interface IMonitoringAssetState {
  seenAt: string;
  sinceAt: string;
  status: MonitoringDeviceStatuses;
}

export interface IMonitoredVehicle {
  [key: string]: any;
  id: number;
  deviceInfo: Record<string, string>;
  remarks?: string;
  rippleId: string;
  stateInfo: IMonitoringAssetState;
  createdAt: string;
  modifiedAt: string;
}

export interface IMonitoringAssetForm {
  id: string;
  tracker: ISelectOption<string> | null;
  remarks: string;
}
